<template>
  <div class="consulting-container">
    <Header></Header>
    
    <!-- 切换标签 -->
    <div class="tab-container">
      <el-radio-group v-model="activeTab" size="large">
        <el-radio-button label="online">在线咨询</el-radio-button>
        <el-radio-button label="phone">电话咨询</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 三栏布局内容区 -->
    <div class="content-container">
      <OnlineConsulting v-if="activeTab === 'online'" />
      <PhoneConsulting v-if="activeTab === 'phone'" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import OnlineConsulting from './components/OnlineConsulting.vue'
import PhoneConsulting from './components/PhoneConsulting.vue'

export default {
  name: 'Consulting',
  components: {
    Header,
    OnlineConsulting,
    PhoneConsulting
  },
  data() {
    return {
      activeTab: 'online' // 默认显示在线咨询
    }
  }
}
</script>

<style lang="less" scoped>
.consulting-container {
  min-height: 100vh;
  background: #f0f2f5;

  .tab-container {
    padding: 20px 0;
    text-align: center;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  .content-container {
    margin: 24px auto;
    width: 95%;
    min-height: calc(100vh - 180px);
  }
}
</style>
